var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c("div", { staticClass: "section-wrapper w-100" }, [
        _c(
          "div",
          { staticClass: "card", attrs: { id: "applicants-credit-reports" } },
          [
            _c("credit-applicants", {
              attrs: {
                errors: _vm.errors,
                "missing-filogix-details-or-access":
                  !_vm.requestCreditBureausRight ||
                  _vm.missingFilogixDetailsForCreditPulls,
                loading: _vm.loadingCreditSubjects,
              },
              on: {
                requestCB: _vm.requestBureau,
                requestAML: _vm.requestAMLService,
                requestPEP: _vm.requestPEPService,
                print: _vm.handlePrintConsent,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card", attrs: { id: "historical-credit-reports" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("div", { staticClass: "row align-items-end" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h2", { staticClass: "section-separator-title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.creditBureau.historicalCreditReports"
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("credit-report-table", {
                  ref: "creditReportTable",
                  attrs: {
                    "application-id": _vm.applicationId,
                    "client-username": _vm.clientUsername,
                    "agent-username": _vm.agentUsername,
                    "credit-reports": _vm.creditReports,
                    loading: _vm.loadingCreditReports,
                  },
                  on: {
                    "copy-liabilities": _vm.handleCopyLiabilities,
                    "change-submit-to-lender": _vm.handleChangeSubmitToLender,
                    "preview-credit-report": _vm.handlePreviewCreditReport,
                  },
                }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card", attrs: { id: "additional-credit-reports" } },
          [
            _c("div", { staticClass: "card-header" }, [
              _c("div", { staticClass: "row align-items-end" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h2", { staticClass: "section-separator-title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t(
                            "direct-to-lender.creditBureau.additionalCreditReports"
                          )
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("additional-credit-report-table", {
                  ref: "additionalCreditReportTable",
                  attrs: {
                    "credit-reports": _vm.additionalReports,
                    loading: _vm.loadingAdditionalReports,
                  },
                  on: {
                    "preview-additional-report":
                      _vm.handlePreviewAdditionalReport,
                  },
                }),
              ],
              1
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("document-preview-modal", {
        ref: "previewCreditModal",
        attrs: {
          "allow-download": false,
          "document-id": _vm.currentDocumentId,
          url: _vm.currentUrl,
          "modal-dialog-size": _vm.displayClassicLayout ? "lg" : "xxl",
          loading: _vm.loadingReportPdf,
          "header-close-button": "",
        },
        on: {
          "download-document": _vm.handleDownloadCreditReport,
          hide: _vm.resetReportDocumentData,
        },
        scopedSlots: _vm._u([
          {
            key: "header-custom",
            fn: function (ref) {
              var loading = ref.loading
              return [
                _c(
                  "b-row",
                  { staticClass: "w-100" },
                  [
                    _c("b-col", [
                      _c("h5", { staticClass: "bold align-self-center m-0" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isAMLReport
                                ? _vm.$t(
                                    "direct-to-lender.creditBureau.amlAssist"
                                  )
                                : _vm.isCreditReport
                                ? _vm.$t(
                                    "direct-to-lender.creditBureau.creditReport"
                                  )
                                : _vm.isPEPReport
                                ? _vm.$t(
                                    "direct-to-lender.creditBureau.pepOrSanctions"
                                  )
                                : ""
                            ) +
                            "\n          "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.showLayoutToggler
                      ? _c(
                          "b-col",
                          { staticClass: "d-flex justify-content-end" },
                          [
                            _c("div", [
                              _c("span", { staticClass: "mx-2" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t(
                                        "direct-to-lender.creditBureau.displayClassicLayout"
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.words.no")) +
                                  "\n            "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mr-3 ml-0 pretty mb-2 p-switch p-fill",
                                  class: { disabled: loading },
                                },
                                [
                                  _c("input", {
                                    attrs: {
                                      id: "layout-toggle",
                                      type: "checkbox",
                                    },
                                    domProps: {
                                      value: _vm.displayClassicLayout,
                                    },
                                    on: { click: _vm.handleToggleReportLayout },
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "state" }, [
                                    _c("label", {
                                      staticClass: "clickable ml-1",
                                    }),
                                  ]),
                                ]
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("global.words.yes")) +
                                  "\n          "
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }